<template lang="pug">
  .string-item
    template(v-if="editMode")
      input(:class="['input', inputClass, {error: !!error}]" v-model="localValue" @input="updateValue" @change="onChange")
    template(v-else)
      p.p {{value}}
</template>

<script>
export default {
  name: "StringItem",
  props: {
    value: {
      type: String,
      default: "",
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
    },
  },
  methods: {
    updateValue() {
      this.$emit("input", this.localValue);
    },
    onChange() {
      this.$emit("change", this.localValue);
    },
  },
};
</script>